module.exports = __webpack_public_path__ + "assets/img/lxfs.a75616af.png";